((w, d) => {
    const banner = d.querySelector('.Banner');
    if (!banner) {
        return;
    }

    if (banner.hasAttribute('open')) {
        banner.focus();
    }

    const all = banner.querySelectorAll('a, button');
    const first = all[0];
    const last = all[all.length - 1];


    banner.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && e.shiftKey && e.target === banner) {
            e.preventDefault();
            last.focus();
        }
    });

    first.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
            e.preventDefault();
            last.focus();
        }
    });

    last.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            first.focus();
        }
    });
})(window, document);
